module.exports = __webpack_public_path__ + "static/customs-policy-deb0f8c38aa543076e36240478633596.png";